import { useLayout } from 'stores/LayoutStore'
import { observer } from 'mobx-react-lite'
import { PropsWithChildren, useCallback, useEffect, useState } from 'react'
import Styles from './MobileWriterToolbarContainer.module.scss'

export const MobileWriterToolbarContainer = observer(({ children }: PropsWithChildren) => {
  const layout = useLayout()
  const [style, setStyle] = useState({})

  const viewportHandler = useCallback(() => {
    const layoutViewport = layout.viewport

    const viewport = window.visualViewport
    const offsetLeft = viewport?.offsetLeft || 0
    const viewportHeight = viewport?.height || 0
    const viewportOffSetTop = viewport?.offsetTop || 0
    const layoutViewportHeight = layoutViewport?.getBoundingClientRect().height || 0

    const offsetTop = viewportHeight - layoutViewportHeight + viewportOffSetTop
    setStyle({ transform: `translate(${offsetLeft}px, ${offsetTop}px) scale(${1 / (viewport?.scale || 1)})` })
  }, [layout.viewport])

  useEffect(() => {
    window.visualViewport?.addEventListener('scroll', viewportHandler)
    window.visualViewport?.addEventListener('resize', viewportHandler)

    return () => {
      window.visualViewport?.removeEventListener('scroll', viewportHandler)
      window.visualViewport?.removeEventListener('resize', viewportHandler)
    }
  }, [viewportHandler])

  return (
    <div
      style={style}
      className={Styles.container}
      ref={(node) => {
        layout.setMobileWriterToolbar(node)
      }}
    >
      {children}
    </div>
  )
})
